export const isScreenLocked = (): boolean => {
  return !!document.getElementById('verify_pin');
};
